<template>
    <div>
        <div class="sticky-quotation-wrapper-2">
            <b-button
                class="btn btn-success btn-block my-2 sticky-button-2"
                v-b-modal.customOfferModal
                >Egyedi ajánlatot kérek
            </b-button>
        </div>

        <button
            v-if="userLogged"
            type="button"
            class="btn btn-success btn-lg btn-block my-2"
            @click="onCallbackRequest"
        >
            Egyedi ajánlatot kérek
        </button>

        <b-button
            v-else
            class="btn btn-success btn-lg btn-block my-2"
            v-b-modal.customOfferModal
            >Egyedi ajánlatot kérek</b-button
        >

        <b-modal
            id="customOfferModal"
            title="Egyedi ajánlatot kérek"
            hide-footer
        >
            <h5 v-if="wegotit">
                Egyedi ajánlatkérésedet megkaptuk, hamarosan felvesszük veled a
                kapcsolatot!
            </h5>
            <b-form @submit.prevent="onSubmit" v-else>
                <b-form-group
                    label="Cégnév *"
                    label-for="company_name"
                    :state="customOfferForm.errors.state('company_name')"
                    :invalid-feedback="
                        customOfferForm.errors.get('company_name')
                    "
                >
                    <b-form-input
                        id="company_name"
                        v-model="customOfferForm.data.company_name"
                        :state="customOfferForm.errors.state('company_name')"
                    />
                </b-form-group>

                <b-form-group
                    label="Vezetéknév"
                    label-for="surname"
                    :state="customOfferForm.errors.state('surname')"
                    :invalid-feedback="customOfferForm.errors.get('surname')"
                >
                    <b-form-input
                        id="surname"
                        v-model="customOfferForm.data.surname"
                        :state="customOfferForm.errors.state('surname')"
                    />
                </b-form-group>

                <b-form-group
                    label="Keresztnév"
                    label-for="forename"
                    :state="customOfferForm.errors.state('forename')"
                    :invalid-feedback="customOfferForm.errors.get('forename')"
                >
                    <b-form-input
                        id="name"
                        v-model="customOfferForm.data.forename"
                        :state="customOfferForm.errors.state('forename')"
                    />
                </b-form-group>

                <b-form-group
                    label="Email *"
                    label-for="email"
                    :state="customOfferForm.errors.state('email')"
                    :invalid-feedback="customOfferForm.errors.get('email')"
                >
                    <b-form-input
                        id="email"
                        v-model="customOfferForm.data.email"
                        type="email"
                        :state="customOfferForm.errors.state('email')"
                    />
                </b-form-group>
                <b-form-group
                    label="Mobil telefonszám"
                    label-for="phone"
                    :state="customOfferForm.errors.state('phone')"
                    :invalid-feedback="customOfferForm.errors.get('phone')"
                >
                <b-form-input
                    id="phone"
                    v-model="customOfferForm.data.phone"
                    type="tel"
                    pattern="(\+[0-9]+|[0-9]+)"
                    inputmode="numeric"
                    :state="customOfferForm.errors.state('phone')"
                />
                </b-form-group>

                <b-form-group
                    label="Üzenet"
                    label-for="message"
                    :state="customOfferForm.errors.state('message')"
                    :invalid-feedback="customOfferForm.errors.get('message')"
                >
                    <b-form-textarea
                        id="message"
                        v-model="customOfferForm.data.message"
                        :state="customOfferForm.errors.state('message')"
                        no-resize
                        :rows="5"
                        maxlength="900"
                        @input="msgLen = ($event || '').length"
                    />
                    <small class="text-muted">{{ msgLen }} / 900 karakter</small>
                </b-form-group>

                <p>
                    <small
                        >A küldés gomb megnyomásával elfogadom az Általános
                        Szerződési Feltételeket és az Adatvédelmi
                        nyilatkozatot.</small
                    >
                </p>
                <button
                    type="submit"
                    class="btn mt-3 btn btn-success btn-lg btn-block btn-secondary"
                >
                    <i class="fas fa-paper-plane mr-2"></i>ELKÜLD
                </button>
            </b-form>
        </b-modal>

        <div class="mt-3">
            Kalkuláció azonosító:
            <strong
                ><a :href="lead.publicUrl">{{ lead.id }}</a></strong
            >
        </div>
        <div class="mt-2">
            Hívd ügyfélszolgálatunkat a
            <strong><a href="tel:+3618000088">+36 1 800-00-88</a></strong
            >-as számon, vagy kérj visszahívást!
        </div>

        <a
            :href="lead.publicUrl"
            class="btn btn-outline-secondary btn-sm btn-block mt-4"
        >
            <i class="fas fa-pen mr-2"></i>Módosítom
        </a>

        <button
            type="button"
            :disabled="saved"
            class="btn btn-outline-secondary btn-sm btn-block"
            @click="onSave()"
        >
            <template v-if="!saved">
                <i class="fas fa-bookmark mr-2"></i> Kalkuláció mentése
            </template>
            <template v-if="saved">
                <i class="fas fa-check mr-2"></i> Kalkuláció elmentve
            </template>
        </button>

        <button
            :disabled="sent"
            type="button"
            class="btn btn-outline-secondary btn-sm btn-block"
            @click="sendInEmail"
        >
            <template v-if="!sent">
                <i class="fas fa-paper-plane mr-2"></i>Kérem e-mailben
            </template>
            <template v-if="sent">
                <i class="fas fa-paper-plane mr-2"></i>Elküldve e-mailben
            </template>
        </button>

        <b-modal ref="send-modal" hide-footer title="Küldés emailben">
            <b-form ref="form" @submit.prevent="onEmail">
                <b-form-group
                    label="Email"
                    label-for="name-input"
                    :invalid-feedback="emailForm.errors.get('email')"
                    :state="emailForm.errors.state('email')"
                >
                    <b-form-input
                        id="email-input"
                        v-model="emailForm.data.email"
                        type="email"
                        :state="emailForm.errors.state('email')"
                        required
                    />
                </b-form-group>

                <p>
                    Az email cím megadásával hozzájárulok, hogy a NetLízing Zrt.
                    emailt küldjön részemre.
                </p>
                <b-button
                    class="mt-3 btn btn-success btn-lg btn-block"
                    type="submit"
                    ><i class="fas fa-paper-plane mr-2"></i>Kérem e-mailben
                </b-button>
            </b-form>
        </b-modal>

        <b-modal ref="sent-modal" hide-footer title="Elküldve">
            Kalkulációdat elküldtük emailben!
        </b-modal>
    </div>
</template>

<script>
import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import VueForm from "~/form/form";
import {
    trackFormSubmission,
    trackPurchase
} from "../../../services/trackingService";
import { trackQuotation } from "../../../services/quotationTrackingService";
import { submitToMiniCrm } from "../../../services/miniCrmService";

const configuratorModule = namespace("configurator");

@Component
export default class ConfirmButtons extends Vue {
    @Prop(Object) lead;
    @Prop(Boolean) userLogged;
    @configuratorModule.Action("setLeadSaved") setLeadSaved;
    @configuratorModule.Action("sendLead") sendLead;
    @configuratorModule.Action("initialize") initialize;
    @configuratorModule.Action("loadLead") loadLead;
    @configuratorModule.Action("getCustomOffer") getCustomOffer;

    email = "";
    saved = false;
    sent = false;
    wegotit = false;
    msgLen = 0;

    customOfferForm = new VueForm({
        surname: null,
        forename: null,
        company_name: null,
        email: null,
        phone: null,
        email_confirmation: null,
        message: null,
        tax_number: null,
        terms: 1,
        newsletter: 1
    });

    emailForm = new VueForm({
        email: "",
        lead_id: null
    });

    mounted() {
        this.emailForm.data.lead_id = this.lead.id;
        this.customOfferForm.data.offer_id = this.lead.id;
        document.getElementById("sticky-quotation-wrapper").remove();
    }

    async onCallbackRequest() {
        try {
            const lead = await this.getCustomOffer(this.lead.id);

            // Get the user data from window.netlizing
            const userData = {};

            // Only add email and phone if they exist
            if (window.netlizing?.user?.email) {
                userData.email = window.netlizing.user.email;
            }
            if (window.netlizing?.user?.phone) {
                userData.phone = window.netlizing.user.phone;
            }
            if (window.netlizing?.user?.id) {
                userData.user_id = window.netlizing.user.id;
            }

            // Get the transaction value from the page
            let value = "0";

            // Try to get the monthly payment value from the DOM
            const monthlyPaymentElement = document.querySelector(
                ".offer-summary-row.highlighted .col-value"
            );
            if (monthlyPaymentElement) {
                const monthlyPaymentText = monthlyPaymentElement.textContent.trim();
                // Extract numeric value from text like "503 987 Ft + ÁFA / hó"
                const match = monthlyPaymentText.match(/(\d[\d\s]+)/);
                if (match && match[1]) {
                    // Remove spaces and convert to number
                    value = match[1].replace(/\s/g, "");
                }
            } else if (this.lead.final_calculated_price) {
                // Fallback to the lead data if available
                value = this.lead.final_calculated_price.toString();
            }

            // Track the custom offer request and wait for it to complete
            await trackPurchase(
                {
                    formId: "custom-offer-request",
                    marketing: true,
                    userDataConsent: true,
                    quotationId: this.lead.id
                },
                userData,
                {
                    transaction_id: `custom-offer-${
                        this.lead.id
                    }-${Date.now()}`,
                    currency: "HUF",
                    value: value,
                    quotationId: this.lead.id
                }
            );

            // Also track via dataLayer and wait for it to complete
            await trackQuotation({
                quotation_id: this.lead.id,
                email: userData.email || "",
                phone: userData.phone || "",
                first_name: userData.first_name || "",
                last_name: userData.last_name || "",
                company: userData.company || ""
            });

            // Only navigate after tracking is complete
            if (!this.userLogged) {
                location.href = "/hu/login_form";
            } else {
                location.href = "/hu/koszonjuk-ajanlatkeresed?lead=" + lead.id;
            }
        } catch (error) {
            console.error("Error during callback request:", error);
        }
    }

    async onSave() {
        try {
            const lead = await this.setLeadSaved(this.lead.id);

            if (lead) {
                this.saved = true;

                // Only navigate after operation is complete
                if (!this.userLogged) {
                    location.href = "/hu/login_form";
                } else {
                    location.href = "/hu/profil/mentett-kalkulaciok";
                }
            }
        } catch (error) {
            console.error("Error saving lead:", error);
        }
    }

    async onEmail() {
        try {
            const lead = await this.emailForm.post("/leadssend");

                    if (lead) {
            // Run tracking and MiniCRM submission in parallel
            await Promise.allSettled([
                trackFormSubmission(
                    "email-request",
                    this.emailForm.data,
                    {
                        marketing: true,
                        userDataConsent: true,
                        transactionId: `email-request-${Date.now()}`,
                        quotationId: this.lead.id
                    }
                ),
                submitToMiniCrm(
                    "email-request",
                    {
                        company_name: "", // Let backend apply default: "E-mail Ajánlatkérés"
                        first_name: "", // Let backend apply default: "No Info"
                        last_name: "", // Let backend apply default: "No Info"
                        email: this.emailForm.data.email,
                        phone: "", // Let backend apply default: "000000000"
                        message: `Email request for lead ${this.lead.id}`,
                        gdpr: true
                    }
                )
            ]);

                // Also track via dataLayer and wait for it to complete
                await trackQuotation({
                    quotation_id: this.lead.id,
                    email: this.emailForm.data.email || "",
                    phone: "",
                    first_name: "",
                    last_name: "",
                    company: ""
                });

                // Only navigate after tracking is complete
                location.href = "/hu/koszonjuk-ajanlatkeresed?lead=" + lead.id;
            }
        } catch (error) {
            console.error("Error sending email:", error);
        }
    }

    async sendInEmail() {
        if (this.userLogged == true) {
            this.sent = true;

            try {
                const lead = await this.sendLead({
                    lead_id: this.lead.id,
                    email: this.email
                });

                if (lead) {
                    // Get the user data from window.netlizing
                    const userData = {};

                    // Only add email and phone if they exist
                    if (window.netlizing?.user?.email) {
                        userData.email = window.netlizing.user.email;
                    }
                    if (window.netlizing?.user?.phone) {
                        userData.phone = window.netlizing.user.phone;
                    }
                    if (window.netlizing?.user?.id) {
                        userData.user_id = window.netlizing.user.id;
                    }

                    // Get the transaction value from the page
                    let value = "0";

                    // Try to get the monthly payment value from the DOM
                    const monthlyPaymentElement = document.querySelector(
                        ".offer-summary-row.highlighted .col-value"
                    );
                    if (monthlyPaymentElement) {
                        const monthlyPaymentText = monthlyPaymentElement.textContent.trim();
                        // Extract numeric value from text like "503 987 Ft + ÁFA / hó"
                        const match = monthlyPaymentText.match(/(\d[\d\s]+)/);
                        if (match && match[1]) {
                            // Remove spaces and convert to number
                            value = match[1].replace(/\s/g, "");
                        }
                    } else if (this.lead.final_calculated_price) {
                        // Fallback to the lead data if available
                        value = this.lead.final_calculated_price.toString();
                    }

                    // Track the email request and wait for it to complete
                    await trackPurchase(
                        {
                            formId: "email-request-logged-in",
                            marketing: true,
                            userDataConsent: true,
                            quotationId: this.lead.id
                        },
                        userData,
                        {
                            transaction_id: `email-request-${
                                this.lead.id
                            }-${Date.now()}`,
                            currency: "HUF",
                            value: value,
                            quotationId: this.lead.id
                        }
                    );

                    // Also track via dataLayer and wait for it to complete
                    await trackQuotation({
                        quotation_id: this.lead.id,
                        email: userData.email || "",
                        phone: userData.phone || "",
                        first_name: userData.first_name || "",
                        last_name: userData.last_name || "",
                        company: userData.company || ""
                    });

                    // Show modal after tracking is complete
                    this.$refs["sent-modal"].show();
                }
            } catch (error) {
                console.error("Error sending email:", error);
            }
        } else {
            this.$refs["send-modal"].show();
        }
    }

    async onSubmit() {
        try {
            const response = await this.customOfferForm.post(
                "/hu/regisztracio/egyediajanlat"
            );

            // Run tracking and MiniCRM submission in parallel
            await Promise.allSettled([
                trackFormSubmission(
                    "custom-offer",
                    this.customOfferForm.data,
                    {
                        marketing: true,
                        userDataConsent: true,
                        transactionId: `custom-offer-${Date.now()}`,
                        quotationId: this.lead.id
                    }
                ),
                submitToMiniCrm(
                    "custom-offer",
                    {
                        company_name: this.customOfferForm.data.company_name,
                        first_name: this.customOfferForm.data.forename,
                        last_name: this.customOfferForm.data.surname,
                        email: this.customOfferForm.data.email,
                        phone: this.customOfferForm.data.phone,
                        message: this.customOfferForm.data.message,
                        gdpr: this.customOfferForm.data.terms
                    }
                )
            ]);

            // Also track via dataLayer and wait for it to complete
            await trackQuotation({
                quotation_id: this.lead.id,
                email: this.customOfferForm.data.email || "",
                phone: this.customOfferForm.data.phone || "",
                first_name: this.customOfferForm.data.forename || "",
                last_name: this.customOfferForm.data.surname || "",
                company: this.customOfferForm.data.company_name || ""
            });

            // Only navigate after tracking is complete
            location.href = response;
        } catch (error) {
            console.error("Error submitting form:", error);
            if (error.user_exists == true) {
                window.location.replace("/");
            }
        }
    }
}
</script>
<style>
.sticky-quotation-wrapper-2 {
    position: fixed;
    top: 25vh;
    right: 0;
    z-index: 1000 !important;
}

.sticky-button-2 {
    font-weight: 600;
    font-size: 1.3rem;
    -webkit-transform: rotate(90deg) translateX(100%);
    transform: rotate(90deg) translateX(100%);
    -webkit-transform-origin: 100% 0%;
    transform-origin: 100% 0%;
}

@media only screen and (max-width: 600px) {
    .sticky-quotation-wrapper-2 {
        position: fixed;
        top: inherit;
        bottom: -8px;
        width: 100%;
        right: 0;
        z-index: 1000;
    }

    .sticky-button-2 {
        font-weight: 600;
        font-size: 1.3rem;
        -webkit-transform: rotate(90deg) translateX(100%);
        transform: inherit;
        -webkit-transform-origin: 100% 0%;
        transform-origin: 100% 0%;
    }
}
</style>
